module.exports = __webpack_public_path__ + "img/programme6.841034e1.png";